import { render, staticRenderFns } from "./FormControlEnum.vue?vue&type=template&id=80daea0c"
import script from "./FormControlEnum.vue?vue&type=script&lang=js"
export * from "./FormControlEnum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports